'use es6';

import http from 'hub-http/clients/apiClient';
const BASE_URI = 'designmanager/v1/modules/by-module-id';
/**
 * GET designmanager/v1/modules/by-module-id/:moduleId
 */

export function fetch(moduleId) {
  return http.get(`${BASE_URI}/${moduleId}`);
}
/**
 * PUT designmanager/v1/modules/by-module-id/:moduleId
 */

export function save(moduleId, data) {
  return http.put(`${BASE_URI}/${moduleId}`, {
    data
  });
}
/**
 * DELETE designmanager/v1/modules/by-module-id/:moduleId
 */

export function del(moduleId) {
  return http.delete(`${BASE_URI}/${moduleId}`);
}
/**
 * DELETE designmanager/v1/modules/by-module-id/bulk?moduleId=1&moduleId=2
 */

export function bulkDelete(moduleIds) {
  return http.delete(`${BASE_URI}s/bulk`, {
    query: {
      moduleId: moduleIds
    }
  });
}
/**
 * POST designmanager/v1/modules/by-module-id/:moduleId/clone
 */

export function clone(moduleId, data = {}) {
  const {
    name: newName,
    schemaVersion,
    isAvailableForNewContent,
    isEnabledForEmailV3Rendering,
    shouldReplaceNestedModules
  } = data;
  return http.post(`${BASE_URI}/${moduleId}/clone`, {
    query: {
      newName
    },
    data: {
      schemaVersion,
      isAvailableForNewContent,
      isEnabledForEmailV3Rendering,
      shouldReplaceNestedModules
    }
  });
}
/**
 * PUT designmanager/v1/modules/by-module-id/:moduleId/restore-deleted
 */

export function restoreDeleted(moduleId) {
  return http.put(`${BASE_URI}/${moduleId}/restore-deleted`);
}